import ActiveRecord from './active_record/base'

class CheckInLocation extends ActiveRecord {
	static tableName = 'checkInLocations'
	static defaultJoins = ['environments']
	static sort = ['name']
}

export default CheckInLocation
